import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";
import {
  generateBreadcrumbStructuredData,
  generateWebPageStructuredData,
} from "../../components/SEO/StructuredData";
import { aiAssistImport } from "../../utility/aiAssistCopy";

const page = aiAssistImport("signups");

const DESCRIPTION =
  "Paper signup sheets still show up at the desk. Photograph the sheet, check each row, and create the teams. Online signups stay available. Free on your first tournament, then AI Assist.";

const SECTIONS = [
  {
    title: "The sheet fills while you are busy",
    body: "Bowlers still write on paper at the desk. After they leave, someone has to type every name, average, and event before the squad is ready.",
  },
  {
    title: "Photograph the sheet and check each row",
    body: "Take a photo of the signup sheet and upload it for that squad. Review each row. Correct a name or average, then create the team when the line is right.",
  },
  {
    title: "Online signups stay available",
    body: "Bowlers can still sign up online. Sheet import is for the paper that shows up at the desk, not a replacement for the public signup page.",
  },
  {
    id: "plans",
    title: "Free on your first tournament",
    body: "Signup sheet import is free on your first tournament. After that it is part of AI Assist.",
    to: "/pricing",
    linkLabel: "Plans",
  },
];

const BowlingTournamentSignupSheetImport = () => (
  <ProductPage
    title={page.title}
    description={DESCRIPTION}
    keywords={[
      "AI signup sheet import tournament",
      "paper signup sheet bowling tournament",
      "bowling tournament signup sheet import",
      "paper signup sheet",
      "AI Assist",
    ]}
    canonicalUrl="/bowling-tournament-signup-sheet-import"
    kicker="AI Assist"
    heading={page.heading}
    lede={page.lede}
    screenshot={PRODUCT_SCREENSHOTS[page.pageShotKey]}
    analyticsLocation="product_signup_sheet_import"
    sectionHeading="Paper at the desk, without retyping the roster"
    sections={SECTIONS}
    secondaryTo="/pricing"
    secondaryLabel="Plans"
    structuredData={generateWebPageStructuredData({
      name: page.title,
      description: DESCRIPTION,
      url: "/bowling-tournament-signup-sheet-import",
      dateModified: "2026-11-04",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "Signups", path: "/bowling-tournament-signups" },
        {
          label: "Signup sheet import",
          path: "/bowling-tournament-signup-sheet-import",
        },
      ]),
    ]}
  />
);

export default BowlingTournamentSignupSheetImport;
